interface IApiConcurrencyError {
    isApiConcurrencyError: true
}

export const isApiConcurrencyError = (error: any) => error && error.isApiConcurrencyError === true;

export default IApiConcurrencyError;